// extracted by mini-css-extract-plugin
export default {"scrollbar_primary":"commonStyles_scrollbar_primary__Za58I","force_overflow":"commonStyles_force_overflow__JKQQf"};